var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState, } from 'react';
import { HintBase, Text } from './styled';
export const LINE_HEIGHT = 24;
export function Hint(_a) {
    var { children, maxLines = 2, readLessLabel = 'read less', readMoreLabel = 'read more' } = _a, props = __rest(_a, ["children", "maxLines", "readLessLabel", "readMoreLabel"]);
    const [open, setOpen] = useState(false);
    const [lines, setLines] = useState(0);
    const ref = useRef();
    useEffect(() => {
        const { offsetHeight: height } = ref.current;
        setLines(height / LINE_HEIGHT);
    }, []);
    function renderButton() {
        if (lines > maxLines) {
            return (React.createElement("button", { type: "button", onClick: () => setOpen(!open) }, open ? readLessLabel : readMoreLabel));
        }
        return null;
    }
    return (React.createElement(HintBase, Object.assign({ ref: ref }, props),
        React.createElement(Text, { "$maxLines": maxLines, "$lines": lines, "$open": open }, children),
        renderButton()));
}
export default Hint;
